const ProductRequestOptionsEnum = Object.freeze({
  BESPOKE: 'Bespoke'
})

export { ProductRequestOptionsEnum }



// WEBPACK FOOTER //
// ./src/common/enum/ProductRequestOptionsEnum.js